export default "__VITE_PUBLIC_ASSET__a3be50b2__"